import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <TopicsSection />
        <RankingSection />
        <AppSection />
        <FeaturesSection />
        <CardsSection />
        <MediaSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <FaqSection />
        <CarouselSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}